



















































































































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import IconButton from "@/components/IconButton.vue";
import Page from "@/components/Page.vue";

import store, { CashFlowStore } from "../services/CashFlowStore";
import AccountingYear, { AccountingYearDefaultProps } from "../models/AccountingYear";
import eventBus from "@/services/eventBus";
import GlobalStore from "@/models/GlobalStore";
import { t } from "@/plugins/i18n";

interface Data {
  store: CashFlowStore;
  newCashFlow: boolean;
  selectedYear: number;
  generalLedgerRiports: any[];
}

interface Methods {
  createCashFlow(generalLedgerRiportId: number, accountingYear: number, isEmpty?: boolean, previousCashFlowRiportId?: number): void;
  editCashFlow(cashFlowRiportId: number): void;
  removeCashFlow(cashFlowRiportId: number): void;
}

interface Computed {
  cashFlowRiportUrl: string;
  cashFlowRiportColumns: ApiSearchColumn[];
  generalLedgerRiportUrl: string;
  generalLedgerRiportColumns: ApiSearchColumn[];
}

export default Vue.extend<Data, Methods, Computed, {}>({
  components: {
    Page,
    ApiSearchPage,
    IconButton
  },

  async beforeMount() {
    await store.loadAccountingYearsFromNow();
    this.selectedYear = this.store.accYears[0].id;
    console.log(GlobalStore.userFeaturePermissions);
    
  },

  data() {
    return {
      store,
      newCashFlow: false,
      selectedYear: 0,
      generalLedgerRiports: []
    };
  },

  methods: {
    async createCashFlow(generalLedgerRiportId, accountingYear, isEmpty, previousCashFlowRiportId) {
      await store.createCashFlowRiport(generalLedgerRiportId, accountingYear, isEmpty, previousCashFlowRiportId);
      this.$router.push(`/cashflow-riport/edit/${this.store.cashFlowRiportHead.id}`);      
    },
    editCashFlow(cashFlowRiportId) {
      this.$router.push(`/cashflow-riport/edit/${cashFlowRiportId}`);
    },
    async removeCashFlow(cashFlowRiportId) {
      await store.removeCashFlowRiport(cashFlowRiportId);
      eventBus.$emit('refreshCashFlows');
    },
  },

  computed: {
    cashFlowRiportUrl() {
      return `cashflow-riport/search`;
    },
    cashFlowRiportColumns: function() {
      return [
        {
          field: "id",
          title: "",
          cell: 'command',
          filterable: false,
          sortable: false,
          fieldClass: "btnCol",
          headerClass: "btnCol",
        },
        {
          field: "id",
          title: t("Azonosito"),
          filterable: false,
          sortable: false,
          fieldClass: "idCol",
          headerClass: "idCol",
        },
        {
          field: "yearName",
          title: t("CashFlowRiport_FokonyviEv"),
          type: ColumnType.Right,
          fieldClass: "yearCol",
          headerClass: "yearCol",
        },
        {
          field: "name",
          title: t("CashFlowRiport_CashFlowElnevezes"),
        },
        {
          field: "remark",
          title: t("Leiras"),
        }
      ];
    },

    generalLedgerRiportUrl() {
      return `generalledger-riport/search/type/7`;
    },
    generalLedgerRiportColumns: function() {
      return [
        {
          field: "id",
          title: "",
          cell: 'command',
          filterable: false,
          sortable: false,
          fieldClass: "btnCol",
          headerClass: "btnCol",
        },
        {
          field: "id",
          title: t("Azonosito"),
          filterable: false,
          sortable: false,
          fieldClass: "idCol",
          headerClass: "idCol",
        },
        {
          field: "yearName",
          title: t("CashFlowRiport_FokonyviEv"),
          type: ColumnType.Right,
          fieldClass: "yearCol",
          headerClass: "yearCol",
        },
        {
          field: "name",
          title: t("CashFlowRiport_RiportSablonNeve"),
        }
      ];
    }
  },

  // watch: {
  //   selectedYear() {
      
  //   }
  // }
});
